<template>
  <div>
    <div :class="state.width > 1024 ? 'pageSidebarGrid':''">
      <main>
        <div class="outline w3-margin">
          <header class="light outline">
            <h5 class="comfortaa">Order Items</h5>
            <p>Update your cart</p>
          </header>
          <table class="w3-table w3-white" :class="state.width > 1024 ? '' : 'w3-responsive'">
            <tr class="w3-light-grey outline">
              <td>Item</td>
              <td class="w3-center" style="min-width:100px;">Period</td>
              <td class="w3-right-align" style="min-width:120px;">Amount</td>
              <td class="w3-right-align" style="min-width:50px;">Actions</td>
            </tr>
            <tr v-for="(item, index) in state.cart.items" :key="index">
              <td>{{item.description}}</td>
              <td class="w3-center">{{item.duration}} {{item.period}}(s)</td>
              <td class="w3-right-align">{{item.amount / 100 | currency}}</td>
              <td class="w3-display-container">
                <button @click="removeCartItem(index)" class="w3-button w3-round-xxlarge w3-red w3-display-middle" style="padding:2px 5px 1px; font-size:7pt;"><i class="fas fa-minus"></i></button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="w3-right-align">Total: {{state.cart.total / 100 | currency}}</td>
              <td></td>
            </tr>
          </table>
        </div>
      </main>
      <aside :class="state.width > 1024 ? 'w3-margin-top' : 'w3-container'" :style="state.width > 1024 ? 'margin-right:8px;':''">
        <paymentMethods :cartView="true"></paymentMethods>
        <div>
          <button @click="checkout()" class="w3-button w3-green w3-block w3-margin-top" :disabled="!checkoutReady">Checkout</button>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import paymentMethods from '@/components/paymentMethods'
var dataStore = require("../dataStore").default;

export default {
  name: 'cart',
  computed: {
    checkoutReady() {
      if (this.state.user.stripeData.default_source) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      state: dataStore.state
    }
  },
  created() {
    let total = 0
    for (let item of this.state.cart.items) {
      total += item.amount
    }
    this.state.cart.total = total
  },
  components: {paymentMethods},
  methods: {
    checkout() {
      let items = []
      for (let cartItem of this.state.cart.items) {
        items.push({'plan': cartItem.plan.id, metadata: {domain: cartItem.domain, custid: this.state.user.custid}})
      }
      let sub = {
        "customer": this.state.user.stripeData.id,
        "items": items
      }
      dataStore.saveSubscription(sub, false).then(result => {
        if (result.data.code == 'success') {
          dataStore.refreshCustomerData()
          this.state.order = result.data.data
          this.state.savedCart = JSON.parse(JSON.stringify(this.state.cart))
          this.state.currentDomainSearch = {}
          this.state.cart = {items: [], total: 0}
          this.$router.replace('checkout-success')
        }
      })
    },
    removeCartItem(index) {
      if (window.confirm('Are you sure you want to remove this item from your cart?')) {
        this.state.cart.items.splice(index, 1)
        let total = 0
        for (let item of this.state.cart.items) {
          total += item.amount
        }
        this.state.cart.total = total
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue